import {
  Grid,
  Checkbox,
  FormControlLabel,
  styled,
  Chip,
  FormHelperText,
  Divider,
} from '@mui/material';
import xor from 'lodash/xor';
import { useFormContext, Controller } from 'react-hook-form';
import {
  WsTypoVariants,
  WsTypography,
  WsColors,
  WSIconTickMark,
  WsIconMinusCircle,
} from 'wisestep-base';

import { IClientOptions } from '../helper/ClientSettingsHelper';

export interface Spoc {
  id: string;
  name: string;
  status?: string;
}

interface ClientSpocsProps {
  clientId?: string;
  spocs?: Spoc[];
  name?: string;
  clientsOptions?: { [key: string]: IClientOptions };
}

const bgcolorStatusMap = new Map();

bgcolorStatusMap.set('Active', WsColors.Green100);
bgcolorStatusMap.set('Inactive', WsColors.TertiaryShades100);

const colorStatusMap = new Map();

colorStatusMap.set('Active', WsColors.Green600);
colorStatusMap.set('Inactive', WsColors.TertiaryShades800);

type ChipIconType = {
  textColor: string;
  bgColor: string;
};

const StyledIconChip = styled(Chip)(({ textColor, bgColor }: ChipIconType) => ({
  color: textColor,
  background: bgColor,
  fontWeight: 700,
  paddingLeft: 5,
  paddingRight: 5,
  borderRadius: 5,
}));
export const StatusIconTypography = (params) => (
  <StyledIconChip
    label={params?.cell}
    icon={IconcolorStatusMap.get(params?.cell)}
    textColor={colorStatusMap.get(params?.cell)}
    bgColor={bgcolorStatusMap.get(params?.cell)}
  />
);
const IconcolorStatusMap = new Map();
IconcolorStatusMap.set('Active', <WSIconTickMark color={colorStatusMap.get('Active')} />);
IconcolorStatusMap.set('Inactive', <WsIconMinusCircle color={colorStatusMap.get('Inactive')} />);

const ClientSpocs = ({ clientId, spocs, name, clientsOptions }: ClientSpocsProps) => {
  const { control } = useFormContext();
  const items = spocs ?? (clientsOptions ? Object.values(clientsOptions) : []);

  const controllerName = (clientId ? `spocs.${clientId}` : name) ?? 'clients';
  return (
    <Controller
      name={controllerName}
      control={control}
      defaultValue={[]}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <>
          <Grid container direction="column" width="25vw">
            {items.map((item, index) => (
              <>
                <FormControlLabel
                  key={item.id}
                  label={
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      display="flex"
                      justifyContent="space-between"
                      width="25vw"
                    >
                      <Grid item xs>
                        <WsTypography variant={WsTypoVariants.BODY1}>{item.name}</WsTypography>
                      </Grid>
                      <Grid item>{item.status && <StatusIconTypography cell={item.status} />}</Grid>
                    </Grid>
                  }
                  control={
                    <Checkbox
                      checked={value?.includes(item.id)}
                      onChange={() => onChange(xor(value, [item.id]))}
                    />
                  }
                />
                {index < items.length - 1 && <Divider />}
              </>
            ))}
          </Grid>
          {error && <FormHelperText color="error">{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default ClientSpocs;
